export default __webpack_public_path__ + "static/media/UiBaremArrow.43c8b319.svg";